import { Card, Grid, Title } from '@mantine/core';
import AvgOrderValueChartComponent from '../../../components/Charts/AvgOrderValueChartComponent';
import CustomerTypeRevenueChart from '../../../components/Charts/CustomerTypeRevenueChart';
import SummaryCard from '../../../components/Dashboard/SummaryCard';
import SummaryTopCard from '../../../components/Dashboard/SummaryTopCard';
import DashboardsCommon from '../../../components/DashboardsCommon';

const RevenueTab = ({ currency, stats, prevStats, customerTypeStats }) => {
  const revenueBySourcePieChartData = stats
    ? stats.purchases.grouped.byRelevaSource.revenue.map((r) => {
        return { id: r.id, label: r.id, value: r.data.reduce((accu, point) => accu + point.y, 0.0) };
      })
    : '';
  const revenueBySourcePreviousPeriodData = prevStats
    ? prevStats.purchases.grouped.byRelevaSource.revenue.map((r) => {
        return { id: r.id, label: r.id, value: r.data.reduce((accu, point) => accu + point.y, 0.0) };
      })
    : '';

  const revenueByUtmSourcePieChartData = stats
    ? stats.purchases.grouped.bySource.revenue.map((r) => {
        return { id: r.id, label: r.id, value: r.data.reduce((accu, point) => accu + point.y, 0.0) };
      })
    : '';
  const prevRevenueByUtmSourcePieChartData = prevStats
    ? prevStats.purchases.grouped.bySource.revenue.map((r) => {
        return { id: r.id, label: r.id, value: r.data.reduce((accu, point) => accu + point.y, 0.0) };
      })
    : '';

  const revenueByUtmMediumPieChartData = stats
    ? stats.purchases.grouped.byMedium.revenue.map((r) => {
        return { id: r.id, label: r.id, value: r.data.reduce((accu, point) => accu + point.y, 0.0) };
      })
    : '';
  const prevRevenueByUtmMediumPieChartData = prevStats
    ? prevStats.purchases.grouped.byMedium.revenue.map((r) => {
        return { id: r.id, label: r.id, value: r.data.reduce((accu, point) => accu + point.y, 0.0) };
      })
    : '';

  const avgOrderValueByUtmSourcePieData = stats
    ? stats.aov.grouped.bySource
        .filter((r) => r.value !== null)
        .map((r) => {
          return { id: r.id, label: r.id, value: r.value };
        })
    : '';
  const prevAvgOrderValueByUtmSourcePieData = prevStats
    ? prevStats.aov.grouped.bySource.map((r) => {
        return { id: r.id, label: r.id, value: r.value };
      })
    : '';

  const avgOrderValueByUtmMediumPieData = stats
    ? stats.aov.grouped.byMedium.map((r) => {
        return { id: r.id, label: r.id, value: r.value };
      })
    : '';
  const prevAvgOrderValueByUtmMediumPieData = prevStats
    ? prevStats.aov.grouped.byMedium.map((r) => {
        return { id: r.id, label: r.id, value: r.value };
      })
    : '';

  return (
    <>
      <Grid data-tour="summaryCard" pt="sm">
        <SummaryCard
          currentPeriodData={revenueBySourcePieChartData}
          previousPeriodData={revenueBySourcePreviousPeriodData}
          currency={currency}
          size="auto"
        />
      </Grid>
      <Grid mt="md">
        <Grid.Col span={12} data-tour="relevaVsOtherChart">
          <DashboardsCommon
            stats={stats.purchases.grouped.byRelevaSource.revenue
              .filter((stat) => stat.id !== 'other')
              .filter((obj) => obj.data.some((dataPoint) => dataPoint.y !== 0))}
            pieChartData={[
              {
                id: 'releva',
                label: 'Releva Contributed',
                value: stats.purchases.assisted.revenue,
                color: 'var(--mantine-color-primary-filled)',
              },
              {
                id: 'other',
                label: 'Other',
                value: stats.purchases.other.revenue,
                color: 'var(--mantine-color-gray-3)',
              },
            ]}
            chartTitle="Releva Contributed vs Other Revenue"
            currency={currency}
            lineStacked={false}
            type={'card'}
          />
        </Grid.Col>
      </Grid>
      <Grid mt="md">
        <Grid.Col span={12}>
          <CustomerTypeRevenueChart data={customerTypeStats} currency={currency} />
        </Grid.Col>
      </Grid>
      <br />
      <Grid>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <SummaryTopCard
            stats={stats.purchases.grouped.bySource.revenue}
            chart={'line'}
            currentPeriodData={revenueByUtmSourcePieChartData}
            previousPeriodData={prevRevenueByUtmSourcePieChartData}
            currency={currency}
            badgeName="Top 3 Store revenue by source"
            numElements={3}
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6 }} data-tour="storeRevenueMedium">
          <SummaryTopCard
            stats={stats.purchases.grouped.byMedium.revenue}
            chart={'line'}
            currentPeriodData={revenueByUtmMediumPieChartData}
            previousPeriodData={prevRevenueByUtmMediumPieChartData}
            currency={currency}
            badgeName="Top 3 Store revenue by medium"
            numElements={3}
          />
        </Grid.Col>
      </Grid>
      <br />
      <Grid>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <SummaryTopCard
            chart={false}
            currentPeriodData={avgOrderValueByUtmSourcePieData}
            previousPeriodData={prevAvgOrderValueByUtmSourcePieData}
            currency={currency}
            badgeName="Top 3 Average order value by source"
            numElements={3}
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <SummaryTopCard
            chart={false}
            currentPeriodData={avgOrderValueByUtmMediumPieData}
            previousPeriodData={prevAvgOrderValueByUtmMediumPieData}
            currency={currency}
            badgeName="Top 3 Average order value by medium"
            numElements={3}
          />
        </Grid.Col>
      </Grid>
      <Card padding="md" radius="md" withBorder mt="md">
        <Title order={6}>Average Order Value</Title>
        <Grid>
          <Grid.Col span={{ base: 12, sm: 6 }} ta="center">
            <AvgOrderValueChartComponent
              data={avgOrderValueByUtmSourcePieData}
              title="Top 10 sources"
              currency={currency}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 6 }} ta="center">
            <AvgOrderValueChartComponent
              data={avgOrderValueByUtmMediumPieData}
              title="Top 10 media"
              currency={currency}
            />
          </Grid.Col>
        </Grid>
      </Card>
    </>
  );
};

export default RevenueTab;
